import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


if ($('.quote-slider').length) {

	let quoteSlider = null;
	let isDesktop = null;

	// Creative effect slides quotes up/down by the slider's full height
	let setQuoteTranslate = function() {
		let quoteHeight = $('#quoteSwiper').outerHeight();
		let creative = quoteSlider.params.creativeEffect;

		creative.prev.translate = [0, '-'+quoteHeight+'px', 0];
		creative.next.translate = [0, quoteHeight+'px', 0];
	}

	let initQuotes = function() {

		if (quoteSlider)
			quoteSlider.destroy(true, true);

		isDesktop = $(window).width() > 768;

		if (isDesktop) {

			quoteSlider = new Swiper('.quote-slider .swiper', {
				loop: true,
				speed: 1500,
				effect: 'creative',
				creativeEffect: {
					prev: {
						opacity: 0,
						translate: [0, 0, 0],
					},
					next: {
						opacity: 0,
						translate: [0, 0, 0],
					},
				},
				autoplay: {
					delay: 13000,
				},
			});

			setQuoteTranslate();

		} else {

			quoteSlider = new Swiper('.quote-slider .swiper', {
				loop: true,
				speed: 1500,
				autoplay: {
					delay: 13000,
				},
			});
		}
	}

	// Bound once; always drives the current instance
	$('.quote-slider .next').on('click', function() {
		quoteSlider.slideNext(1500);
	});

	$('.quote-slider .prev').on('click', function() {
		quoteSlider.slidePrev(1500);
	});

	initQuotes();

	// Rebuild only when crossing the breakpoint; otherwise just re-measure
	$(window).on('resize', function() {
		if (($(window).width() > 768) !== isDesktop) {
			initQuotes();
		} else if (isDesktop) {
			setQuoteTranslate();
		}
	});
}
